import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classnames from 'classnames'
import Highlighter from 'react-highlight-words'
import {
  DropdownCard,
  EnumDropdownItemVariant,
  type IDropdownItem,
  InputCheckbox,
  type InputCheckboxProps,
  type ITooltipProps,
  Typography,
} from 'shared/ui'
import { type OutboundSource } from 'entities/OutboundSource/model/OutboundSource'
import styles from './styles.module.scss'

type IOutboundDropdownCardProps = {
  item: OutboundSource
  InputCheckboxProps?: InputCheckboxProps
  onChange?: (item: OutboundSource) => void
  highlighter?: string
  ariaLabel?: string
  tooltipProps?: ITooltipProps
  disabled?: boolean
}

export const OutboundDropdownCard: FC<IOutboundDropdownCardProps> = observer(
  ({ item, onChange, InputCheckboxProps, highlighter, ariaLabel, tooltipProps, disabled }) => {
    const renderContent = (isCheckbox: boolean) => {
      return (
        <div
          className={classnames(styles.wrap, {
            [styles['wrap--checkbox']]: isCheckbox,
          })}
        >
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'outbound-source'}
            className={styles.title}
          >
            {highlighter ? (
              <Highlighter
                highlightClassName={classnames(styles.highlighter, styles['highlighter--label'])}
                className={styles.label}
                searchWords={highlighter.split(' ')}
                autoEscape={true}
                textToHighlight={item.label}
              />
            ) : (
              item.label
            )}
          </Typography>
        </div>
      )
    }
    const dropdown: IDropdownItem = {
      id: item.key,
      label: item.label,
      variant: EnumDropdownItemVariant.Custom,
      renderOption: () => {
        return renderContent(false)
      },
      className: styles.dropdown,
      parentTooltipProps: tooltipProps,
      disabled: disabled,
    }

    if (InputCheckboxProps) {
      return (
        <InputCheckbox
          {...InputCheckboxProps}
          customLabel={renderContent(true)}
          tooltipProps={tooltipProps}
          disabled={disabled}
        />
      )
    }

    return (
      <DropdownCard
        item={dropdown}
        ariaLabel={ariaLabel}
        onChange={() => {
          if (onChange) onChange(item)
        }}
      />
    )
  }
)
